module.exports = __webpack_public_path__ + "img/1f62a.a47578e.svg";